import React from 'react';


/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */
/*
UniPair
PROPS:
props.iconAndTitle // default - row first icon then title
props.iconAboveTitle // column for dual action buutons (like Quick Settings in Windws 11 or Quick Settings tile in Android)
props.sideBySide // row of two rectangles side-by-side (Feature Row, Split Section)
props.reverse // reverse the normal layout for any of the props above
props.extraClass
props.jsx1 // first item in pair
props.jsx2 // secondary item in pair
*/

/*
IDEAS:
iconAndTitle

*/

const UniPair = (props) => {
  /*
  let cl = '';
  if (props.fullWidth === true) { // width to 100%
    cl = " unicompo-limiter--full-width";
  }
  if (props.overflowHidden === true) { // overflow: hidden;
    cl = " unicompo-limiter--overflow-hidden";
  }
  */

  let cl = 'unicompo-pair';
  if (props.tile === true) {
    cl += ' unicompo-pair--tile';
  }
  if (props.iconAndTitle === true) {
    cl += ' unicompo-pair--icon-and-title';
  }
  if (props.secondUnderFirst === true) {
    cl += ' unicompo-pair--btn2-under-btn1';
  }
  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    // extraClass = ' ' + props.extraClass;
    cl += ' ' + props.extraClass;
  }
  let jsx1 = null;
  let jsx2 = null;
  if (props.jsx1) {
    jsx1 = props.jsx1;
  }
  if (props.jsx2) {
    jsx2 = props.jsx2;
  }
  return (
    <div className={cl}>
      <div className="unicompo-pair__first">{jsx1}</div>
      <div className="unicompo-pair__gap"></div>
      <div className="unicompo-pair__second">{jsx2}</div>
    </div>
  );
};

export default UniPair;